export const navigation = {
  dashboard: 'Dashboard',
  referenceData: {
    title: 'Reference Data',
    members: 'Members',
    legalEntities: 'Legal Entities',
    sdxAccounts: 'SDX Accounts',
    assets: 'Assets',
    accounts: 'Accounts',
    whitelistedAddresses: 'Whitelisted Addresses',
    externalEntities: 'External Entities',
    blockchainPlatforms: 'Blockchain Platforms',
  },
  transactions: {
    title: 'Transactions',
    instructions: 'Instructions',
    holdings: 'Holdings',
  },
  operational: {
    title: 'Operational',
    users: 'Users',
  },
  holdings: {
    title: 'Holdings',
  },
  user: {
    logout: 'Logout',
  },
  companyProfile: 'Company Profile',
  userAdministration: 'User Administration',
  assetService: 'Asset Service',
  issuance: 'Issuance',
  nodes: 'Accounts & Positions',
  accounts: 'Accounts & Positions',
  accountsPositions: 'Accounts & Positions',
  assets: 'Asset Overview',
  reports: 'Reports',
  guidesManuals: 'IT Manuals & Guidelines',
  tradingParticipant: 'Trading Participant',
  standingSettlementInstructions: 'Standing Settlement Instruction',
};
